//
// DimensionUnit.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */

var DimensionUnit = {
    PIXELS:0,
    PERCENTAGE:1,
    POINTS:2,
    INCHES:3,
    CENTIMETERS:4,
    MILLIMETERS:5,
    PICAS:6,
    DEVICEPIXELS:7
};
export default DimensionUnit;
